import React from 'react';

const Title = (props) => {
    const fw = props.className ? props.className.includes("fw") ? '' : 'fw-semibold ' : 'fw-semibold';
    const fs = props.className ? props.className.includes("fs") ? '' : 'fs-5 ' : 'fs-5 ';
    const classes = fs + fw + `${props.className ? props.className : ''}`;
    return (
        <h2 className={classes}> {props.children} </h2>
    );
};

export default React.memo(Title);

